import { StatusBadge } from '@/components/common';
import { type ProductRoadmap } from '@/domain/products/types';
import { type RoadMap, type RoadmapListDetail } from '@/domain/roadmap/types';
import { type BasicUserDTO } from '@/domain/user/types';
import { getUserProfilePicture } from '@/domain/user/utils';
import { getImpact, getImpactColor } from '@/features/roadmap/utils';

import { Tooltip } from 'primereact/tooltip';

import styles from './styles.module.scss';

export const OKRsBodyTemplate = ({ okrs, idRoadmap }: RoadMap | ProductRoadmap) => (
  <div>
    {[...okrs]
      .sort((a, b) => b.impact - a.impact)
      .map(({ id, alias, impact, description, name }) => (
        <div key={id} className={styles.badgeWrapper}>
          <Tooltip target={`[id='${id}-${idRoadmap}']`}>
            <div>
              <div>
                <span className={styles.tooltipImpact}>({getImpact(impact)})</span>
                <span className={styles.tooltipHeader}>{name}</span>
              </div>
              <div>
                <span className={styles.tooltipDescription}>{description}</span>
              </div>
            </div>
          </Tooltip>
          <div id={`${id}-${idRoadmap}`}>
            <StatusBadge color={getImpactColor(impact)}>{alias ?? name}</StatusBadge>
          </div>
        </div>
      ))}
  </div>
);

export const fundingSourceTemplate = <T extends RoadmapListDetail>({ idRoadmap, fundingSources }: T) => (
  <div>
    {[...fundingSources]
      .sort((a, b) => (b.name > a.name ? 1 : -1))
      .map(({ idFundingSource, name, alias, percentage }) => (
        <div key={idFundingSource} style={{ margin: '0.3rem 0' }}>
          <Tooltip target={`[id='${idFundingSource}-${idRoadmap}']`} position="top">
            <div>
              <div>
                <span>{name}</span>
              </div>
            </div>
          </Tooltip>
          <div id={`${idFundingSource}-${idRoadmap}`}>
            <StatusBadge breakLine color="green">{`${alias ?? name} (${percentage}%)`}</StatusBadge>
          </div>
        </div>
      ))}
  </div>
);

export const booleanBodyTemplate = (value: boolean) =>
  value ? <StatusBadge color="green">True</StatusBadge> : <StatusBadge color="red">False</StatusBadge>;

export const userAvatarTemplate = (user: BasicUserDTO | null, size = 25) => {
  if (!user) return null;
  const { pictureGuid, name, email } = user;
  return pictureGuid ? (
    <span style={{ verticalAlign: 'middle' }}>
      <img
        style={{ marginRight: '0.5rem', verticalAlign: 'middle' }}
        src={getUserProfilePicture(pictureGuid)}
        alt={name}
        width={size}
        height={size}
      />
      <span style={{ verticalAlign: 'middle' }}>
        {name} - {email}
      </span>
    </span>
  ) : (
    <span style={{ verticalAlign: 'middle' }}>
      {name} - {email}
    </span>
  );
};
